module.exports = __webpack_public_path__ + "img/download.9c37bf85.png";